const { CHANNEL_MIN_BUDGET_PER_CURRENCY } = require('./constants');

function findChannels(ads) {
  let selectedBudgetNames = ['facebook', 'instagram', 'apple', 'kakao', 'microsoft', 'yelp', 'youtube'].filter(
    channelName => ads.some(ad => ad.channel == channelName),
  );
  if (ads.some(ad => ['universalAppV2', 'universalApp'].includes(ad.creativeType))) {
    const universalAppAds = ads.filter(ad => ['universalAppV2', 'universalApp'].includes(ad.creativeType));
    if (universalAppAds.some(ad => ad.creative.playStoreUrl && ad.creative.playStoreUrl.length > 0))
      selectedBudgetNames.push('google_universal_playstore');
    if (universalAppAds.some(ad => ad.creative.appStoreUrl && ad.creative.appStoreUrl.length > 0))
      selectedBudgetNames.push('google_universal_appstore');
  }
  if (ads.some(ad => ad.channel == 'google' && ad.creativeType == 'ResponsiveDisplayAd'))
    selectedBudgetNames.push('google_display');
  if (ads.some(ad => ad.channel == 'google' && ad.creativeType == 'ExpandedTextAd'))
    selectedBudgetNames.push('google_search');
  return selectedBudgetNames;
}

function getMinBudget(currency, channel, isLeadForm = false) {
  if (!currency) currency = 'USD';
  const CHANNEL_MIN_BUDGET = CHANNEL_MIN_BUDGET_PER_CURRENCY[currency];
  if (isLeadForm && ['facebook', 'instagram'].includes(channel)) {
    return CHANNEL_MIN_BUDGET[channel] * 2;
  }
  return CHANNEL_MIN_BUDGET[channel] || CHANNEL_MIN_BUDGET['default'];
}

function selectProposalBudgets({ proposal, currency, isLeadForm = false }) {
  let availableBudgetNames = findChannels(proposal.channelAds);
  let enabledBudgetNames = findChannels(proposal.channelAds.filter(ad => ad.enabled));
  let { budget } = proposal;

  let googleValue = 0;
  let googleBudget = budget.channels.find(c => c.name == 'google');
  if (googleBudget) googleValue = googleBudget.value;

  // For each channel, set budget to zero if no matching creative is enabled
  for (let channel of budget.channels) {
    if (!availableBudgetNames.includes(channel.name)) {
      if (channel.value != 0) channel.memory = channel.value;
      channel.value = 0;
      channel.lifeTimeValue = 0;
      channel.visible = false;
    }
  }

  for (let channelName of availableBudgetNames) {
    let channel = budget.channels.find(c => c.name == channelName);
    if (!channel) {
      channel = {
        name: channelName,
        value: 0,
        memory: 0,
        visible: false,
        min: getMinBudget(currency, channelName, isLeadForm),
      };
      budget.channels.push(channel);
    }
    if (channel.visible == false) {
      channel.value = channel.memory || 0;
    }
    if (channel.value > 0) channel.memory = channel.value;
    channel.visible = true;

    // set budget to zero if no ads are enabled
    if (!enabledBudgetNames.includes(channelName)) {
      if (channel.value > 0) channel.memory = channel.value;
      if (channel.lifeTimeValue > 0) channel.lifeTimeMemory = channel.lifeTimeValue;
      channel.value = 0;
      channel.lifeTimeValue = 0;
    } else {
      // if no value for an enabled channel budget we get it from the memory
      if (!channel.value) channel.value = channel.memory;
      if (!channel.lifeTimeValue) channel.lifeTimeValue = channel.lifeTimeMemory;
    }
  }

  if (googleValue) {
    // migration code
    let googleSubBudgetNames = [
      'google_display',
      'google_search',
      'google_universal_playstore',
      'google_universal_appstore',
    ];
    let allNulls = true;
    let newGoogleSubBudgetNames = googleSubBudgetNames.filter(channelName => {
      let channelBudget = budget.channels.find(c => c.name == channelName);
      if (!channelBudget) return false;
      if (channelBudget.value != 0) allNulls = false;
      if (enabledBudgetNames.includes(channelName)) return true;
      return false;
    });
    if (allNulls) {
      for (let channelName of newGoogleSubBudgetNames) {
        let channelBudget = budget.channels.find(c => c.name == channelName);
        channelBudget.value = googleValue / newGoogleSubBudgetNames.length;
      }
    }
  }

  // update total daily budget
  proposal.budget.daily = proposal.budget.channels.reduce((acc, channelBudget) => acc + (channelBudget.value || 0), 0);
}

module.exports = { selectProposalBudgets, getMinBudget };
